// cant use flow here cause its so complicated with the props / types flowing through the switch case ...

import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import type { Connector } from 'react-redux'
import { closeModal } from 'actions/ui/modals'
import LoginModal from 'modals/loginModal'
import SignupModal from 'modals/signupModal'
import SDayPicker from 'modals/sDayPicker'
import EditCoinPopup from 'modals/editCoinPopup/index.js'

class ModalsManager extends PureComponent {

  generateProps = (modal) => ({
    ...modal.props,
    key: modal.modalID,
    closeModal: () => this.props.closeModal(modal.modalID)
  })

  render = () => {

    return (
      <fb className="modalsMangarMain">
        { this.props.modals.map(m => {
          const props = this.generateProps(m)
          switch (m.modalID){
            case 'EDIT_COIN'           : return <EditCoinPopup key={m.modalID} { ...props } />
            case 'LOGIN_MODAL'         : return <LoginModal    key={m.modalID} { ...props }/>
            case 'SIGNUP_MODAL'        : return <SignupModal  key={m.modalID} { ...props }/>
            case 'UNTIL_DATE_PICKER'   : return <SDayPicker  key={m.modalID} { ...props }/>
            default: return null
          }
        })}
      </fb>
    )
  }
}



const actionCreators = { closeModal }
const mapStateToProps = (state) => ({ modals: state.ui.modals })

const connector: Connector<> = connect(mapStateToProps, actionCreators)
export default connector(ModalsManager)



// WEBPACK FOOTER //
// ./src/containers/modalsManager.js